import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import { ctaSchema, SECTION_DEFAULTS } from "../schemas";

const CtaEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="cta"
    schema={ctaSchema}
    defaults={SECTION_DEFAULTS.cta}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField
          form={form}
          path="card_heading"
          label="Card heading"
          required
        />
        <TextareaField
          form={form}
          path="card_subtitle"
          label="Card subtitle"
          rows={2}
        />
        <TextField
          form={form}
          path="button_label"
          label="Button label"
          required
        />
      </>
    )}
  </EditorShell>
);

export default CtaEditor;
